import { NamedObject } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a NamedObject.
 *
 * @param obj - The value to check
 * @returns True if the value is a NamedObject
 */
export const isNamedObject = (obj: unknown): obj is NamedObject => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check properties exist
  if (typeof obj.name !== "string") return false;
  if (obj.description !== undefined && typeof obj.description !== "string") return false;
  if (obj.label !== undefined && typeof obj.label !== "string") return false;
  // Everything is good
  return true;
};
